export default __webpack_public_path__ + "static/media/ava3.7fd26c24.png";